function clickFooter(e) {
    e.preventDefault();
    const target = e.target;
    const itemLink = target.innerHTML.split(' ')[0].toLowerCase();
    const item = document.querySelector('.item-' + itemLink);
    if (item) {
        item.classList.toggle('d-block');
    }
}
// Show/Hide Footer More Button
let valueOpen = "";
function clickOpen(e) {
    const btn = e.target;
    if (!btn)
        return;
    const isOpen = valueOpen === `true-${btn.id}`;
    btn.innerHTML = isOpen
        ? `Ver más <img src='/themes/custom/ev_theme/assets/images/fontawesome/angle-down-solid.svg'>`
        : `Ver menos <img src='/themes/custom/ev_theme/assets/images/fontawesome/angle-up-solid.svg'>`;
    const items = document.querySelectorAll(`.${btn.id} li:nth-last-child(-n+5)`);
    items.forEach((item) => {
        item.style.display = isOpen ? 'none' : 'block';
    });
    valueOpen = isOpen ? `false-${btn.id}` : `true-${btn.id}`;
}
export function loadEventFooter() {
    window.clickOpen = clickOpen;
    window.clickFooter = clickFooter;
    const optionFooter = Array.from(document.querySelectorAll('.footer-links h4'));
    if (optionFooter.length) {
        optionFooter.forEach((btn) => btn.addEventListener('click', clickFooter));
    }
    document.addEventListener("DOMContentLoaded", () => {
        const btns = Array.from(document.getElementsByClassName('btn-more-list'));
        if (btns.length) {
            btns.forEach((btn) => btn.addEventListener('click', clickOpen));
        }
    });
}
